/* A soft blue-grey track; the selected option is a white pill with a soft shadow and a
   primary label (ADR 0019, ADR 0028). */
.wrap {
  display: inline-flex;
  flex-wrap: wrap;
  align-items: center;
  gap: var(--space-2);
  min-width: 0;
}

.label {
  color: var(--graphite);
  font: var(--t-body);
}

.track {
  display: inline-flex;
  gap: 2px;
  padding: 3px;
  border-radius: var(--radius-control);
  background: var(--wash);
}

.segment {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-height: calc(var(--control-height) - 8px);
  padding: 0 var(--space-3);
  border: 0;
  border-radius: calc(var(--radius-control) - 2px);
  background: transparent;
  color: var(--pencil);
  font: var(--t-body);
  white-space: nowrap;
  cursor: pointer;
  transition:
    background-color var(--dur) var(--ease),
    color var(--dur) var(--ease);
}

.segment[data-hovered] {
  color: var(--ink);
}

.segment[data-selected] {
  background: var(--paper);
  box-shadow: var(--shadow-pill);
  color: var(--brand);
  font-weight: 500;
}

.segment[data-focus-visible] {
  outline: var(--focus-ring);
  outline-offset: 0;
}

.segment[data-disabled] {
  color: var(--pencil);
  cursor: not-allowed;
}

@media (pointer: coarse) {
  .segment {
    min-height: calc(var(--touch-target) - 6px);
  }
}
